import { render, staticRenderFns } from "./WidgetSubtableLayout.vue?vue&type=template&id=4fef6498&scoped=true&"
import script from "./WidgetSubtableLayout.vue?vue&type=script&lang=js&"
export * from "./WidgetSubtableLayout.vue?vue&type=script&lang=js&"
import style0 from "./WidgetSubtableLayout.vue?vue&type=style&index=0&id=4fef6498&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fef6498",
  null
  
)

export default component.exports